import { render, staticRenderFns } from "./vc-carousel.vue?vue&type=template&id=0e0ef2f7&scoped=true&"
import script from "./vc-carousel.vue?vue&type=script&lang=js&"
export * from "./vc-carousel.vue?vue&type=script&lang=js&"
import style0 from "./vc-carousel.vue?vue&type=style&index=0&id=0e0ef2f7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0ef2f7",
  null
  
)

export default component.exports